import axios from 'axios';

/**
 * Make a request to payment-service to resolve the payment
 *
 * @param paymentId
 * @param isManualResolve
 */
export async function resolvePayment(paymentId, isAutomaticResolve = false) {
  const { data: { jwt: bearerToken, url: urlToken } = {} } = await axios.post(
    '/admin/payments/CtsJwt'
  );

  const url = new URL(
    `/payments/${paymentId}/resolve?isAutomaticResolve=${isAutomaticResolve}`,
    urlToken
  );

  const { data } = await axios.request({
    headers: { Authorization: `Bearer ${bearerToken}` },
    method: 'POST',
    url,
  });
  return data.data;
}
